const state = {
  factors: {},
  cart: {
    classification: {},
    question_ids: []
  },
  year: 0,
  diff: -1,
  questiontype: 0,
  region: 0,
  catalog: '',
  kps: [],
  bookorkps: 1,
  defaultbook: [],
  singleormulti: '1',
  book: '',
  diffname: '全部',
  questiontypename: '全部',
  provincename: '全部',

  paperType: 0,
  grade: '',
  textbookVersion: ''
}
export default state
